/**
 * Mapping configuration for external requests table columns
 * Maps UI column IDs to backend filter/sort field names
 */
import { getArrayValue } from '@/lib/utils/table-state-utils';

// Filter mapping: Maps UI filters to backend filters
export const externalRequestsFilterMapping = {
  requestType: (value: any) => ({
    'externalRequestLogs.requestType': getArrayValue(value)
  }),
  service: (value: any) => ({
    'externalRequestLogs.service': getArrayValue(value)
  }),
  eventType: (value: any) => ({
    'externalRequestLogs.eventType': getArrayValue(value)
  }),
  status: (value: any) => ({
    'externalRequestLogs.status': getArrayValue(value)
  }),
  storeId: (value: any) => ({
    'externalRequestLogs.storeId': getArrayValue(value)
  }),
  createdAt: (value: any) => ({
    'externalRequestLogs.createdAt': value
  }),
};

// Query params mapping: Parse URL params
export const externalRequestsQueryParamsMapping = {
  request_type: (value: URLSearchParams) => value.get('request_type')?.split(','),
  service: (value: URLSearchParams) => value.get('service')?.split(','),
  event_type: (value: URLSearchParams) => value.get('event_type')?.split(','),
  status: (value: URLSearchParams) => value.get('status')?.split(','),
  store_id: (value: URLSearchParams) => value.get('store_id')?.split(','),
  created_at: (value: URLSearchParams) => {
    const res = value.get('created_at');
    return res ? JSON.parse(res) : null;
  },
};

// Sort mapping: Maps UI column IDs to backend sort field names
export const externalRequestsSortMapping = {
  requestType: 'requestType' as const,
  service: 'service' as const,
  eventType: 'eventType' as const,
  status: 'status' as const,
  createdAt: 'createdAt' as const,
  requestedAt: 'requestedAt' as const,
  completedAt: 'completedAt' as const,
  responseStatus: 'responseStatus' as const,
  duration: 'duration' as const,
};

